// Declare insuranceSelect variable in the global scope
var insuranceSelect;

// Function to handle the visibility of insurance and warranty details div
function iwAddOns() {
function toggleInsuranceDetails() {
    insuranceSelect = document.querySelector('[data-iw-select="insurance"]');
    var insuranceDetails = document.querySelector('.insurance-details');
    
    if (insuranceSelect.value === 'none' || insuranceSelect.value === 'no-insurance') {
    insuranceDetails.style.display = 'none';
    } else {
    insuranceDetails.style.display = 'block';
    }
}

insuranceSelect = document.querySelector('[data-iw-select="insurance"]');
insuranceSelect.addEventListener('change', toggleInsuranceDetails);

toggleInsuranceDetails();

function toggleWarrantyDetails() {
    warrantySelect = document.querySelector('[data-iw-select="warranty"]');
    var warrantyDetails = document.querySelector('.warranty-details');
    
    if (warrantySelect.value === 'none' || warrantySelect.value === 'no-warranty') {
    warrantyDetails.style.display = 'none';
    } else {
    warrantyDetails.style.display = 'block';
    }
}

warrantySelect = document.querySelector('[data-iw-select="warranty"]');
warrantySelect.addEventListener('change', toggleWarrantyDetails);

toggleWarrantyDetails();
}

document.addEventListener('DOMContentLoaded', iwAddOns);

// Insurance date input field 
var dateInput = document.getElementById('birthdate');

dateInput.addEventListener('input', function() {
var inputValue = dateInput.value.replace(/[^0-9/-]/g, '');

var digitsCount = (inputValue.match(/\d/g) || []).length;
var slashesCount = (inputValue.match(/\//g) || []).length;
var dashesCount = (inputValue.match(/-/g) || []).length;

if (digitsCount > 8) {
    inputValue = inputValue.slice(0, 8);
}
if ((slashesCount + dashesCount) > 2) {
    inputValue = inputValue.slice(0, inputValue.lastIndexOf('/') || inputValue.lastIndexOf('-'));
}

dateInput.value = inputValue;
});

function addSelectCart() {
    // Get the selected insurance product ID from the dropdown
    const insuranceDropdown = document.querySelector('[data-iw-select="insurance"]');
    const selectedInsuranceId = insuranceDropdown ? insuranceDropdown.value : null;
  
    // Get the selected warranty product ID from the dropdown
    const warrantyDropdown = document.querySelector('[data-iw-select="warranty"]');
    const selectedWarrantyId = warrantyDropdown ? warrantyDropdown.value : null;
  
    // Get the birthdate from the input field
    const birthdateInput = document.getElementById('birthdate');
    const birthdate = birthdateInput ? birthdateInput.value : '';
  
    // Get the main product title from the data attribute
    const productTitleElement = document.querySelector('.product__title');
    const productTitle = productTitleElement ? productTitleElement.getAttribute('data-product-title') : '';
  
    // Prepare items to add to the cart
    let itemsToAdd = [];
  
    // Check if the selected insurance value is a valid product ID and add to items
    if (selectedInsuranceId && selectedInsuranceId !== 'none' && selectedInsuranceId !== 'no-insurance') {
      itemsToAdd.push({
        id: selectedInsuranceId,
        quantity: 1,
        properties: {
          'For': productTitle,
          'Date of birth': birthdate
        }
      });
    }
  
    // Check if the selected warranty value is a valid product ID and add to items
    if (selectedWarrantyId && selectedWarrantyId !== 'none' && selectedWarrantyId !== 'no-warranty') {
      itemsToAdd.push({
        id: selectedWarrantyId,
        quantity: 1,
        properties: {
          'For': productTitle
        }
      });
    }
  
    // Proceed to add items to cart if there are any
    if (itemsToAdd.length > 0) {
      const cartAddUrl = '/cart/add.js';
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: itemsToAdd })
      };
  
      fetch(cartAddUrl, config)
        .then(response => response.json())
        .then(response => {
          console.log('Products added to cart:', response);
          // You can update the UI or notify the user here
        })
        .catch(error => console.error('Error adding products to cart:', error));
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    const mainAddButton = document.querySelector('[data-id="main-add-button"]');
    if (mainAddButton) {
      mainAddButton.addEventListener('click', function(evt) {
        setTimeout(() => {
          addSelectCart();
        }, 2000);
      });
    }
  });